// Enum: openfl.utils._internal.format.amf3.AMF3ObjectHeader

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

// Imports

var $estr = require("./../../../../../estr_stub").default;
var $hxEnums = require("./../../../../../hxEnums_stub").default;

// Definition

var AMF3ObjectHeader = $hxEnums["openfl.utils._internal.format.amf3.AMF3ObjectHeader"] = { __ename__ : "openfl.utils._internal.format.amf3.AMF3ObjectHeader", __constructs__ : ["HReference","HTraits","HExternal"]
  ,HTraits: ($_=function(traits) { return {_hx_index:1,traits:traits,__enum__:"openfl.utils._internal.format.amf3.AMF3ObjectHeader",toString:$estr}; },$_.__params__ = ["traits"],$_)
  ,HReference: ($_=function(value) { return {_hx_index:0,value:value,__enum__:"openfl.utils._internal.format.amf3.AMF3ObjectHeader",toString:$estr}; },$_.__params__ = ["value"],$_)
  ,HExternal: ($_=function(className) { return {_hx_index:2,className:className,__enum__:"openfl.utils._internal.format.amf3.AMF3ObjectHeader",toString:$estr}; },$_.__params__ = ["className"],$_)
};

exports.default = AMF3ObjectHeader;